import { render, staticRenderFns } from "./CheckoutUserAddresses.vue?vue&type=template&id=97d00f32"
import script from "./CheckoutUserAddresses.vue?vue&type=script&lang=js"
export * from "./CheckoutUserAddresses.vue?vue&type=script&lang=js"
import style0 from "./CheckoutUserAddresses.vue?vue&type=style&index=0&id=97d00f32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports